<template>
  <Popper arrow hover class="tool-popper" offset-distance="0">
    <!-- TODO: Just use info type, remove other options and remove type prop -->
    <div v-if="props.type === 'info'">
      <InformationCircleIcon class="tooltip-icon" />
    </div>
    <div v-else-if="props.type === 'legacy-info'">
      <svg class="inline" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM8 14.5C4.41563 14.5 1.5 11.5841 1.5 8C1.5 4.41594 4.41563 1.5 8 1.5C11.5844 1.5 14.5 4.41594 14.5 8C14.5 11.5841 11.5844 14.5 8 14.5ZM9.25 10.5H8.75V7.75C8.75 7.3375 8.41562 7 8 7H7C6.5875 7 6.25 7.3375 6.25 7.75C6.25 8.1625 6.5875 8.5 7 8.5H7.25V10.5H6.75C6.3375 10.5 6 10.8375 6 11.25C6 11.6625 6.3375 12 6.75 12H9.25C9.66406 12 10 11.6641 10 11.25C10 10.8359 9.66562 10.5 9.25 10.5ZM8 6C8.55219 6 9 5.55219 9 5C9 4.44781 8.55219 4 8 4C7.44781 4 7 4.44688 7 5C7 5.55312 7.44688 6 8 6Z" fill="#BAC00B"/>
      </svg>
    </div>
    <div v-else-if="props.type === 'legacy-check'">
      <svg class="inline" width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7531 0.718662C14.0719 1.01241 14.0719 1.48741 13.7531 1.75304L5.50313 10.003C5.2375 10.3218 4.7625 10.3218 4.46875 10.003L0.219656 5.75304C-0.0732187 5.48741 -0.0732187 5.01241 0.219656 4.71866C0.5125 4.42804 0.9875 4.42804 1.28031 4.71866L5 8.44054L12.7188 0.718662C13.0125 0.426787 13.4875 0.426787 13.7531 0.718662Z" fill="#BAC00B"/>
      </svg>
    </div>
    <div v-else>
      <slot />
    </div>

    <template v-slot:content>
      <p class="tooltip-message" v-html="props.message"></p>
    </template>
  </Popper>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import {InformationCircleIcon} from "@heroicons/vue/24/outline";

const props = defineProps<{
  type?: "info" | "legacy-info" | "legacy-check";
  message: string;
}>();

document.documentElement.style.setProperty('--env-color', '#15395E');

</script>

<style scoped lang="scss">
@import "@env_styles/variables";

.tool-popper {
  --popper-theme-background-color: var(--env-color);
  --popper-theme-background-color-hover: darken(var(--env-color), 10%);
  --popper-theme-text-color: #FFFFFF;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: none;
  --popper-theme-border-color: none;
  --popper-theme-border-radius: 0.25rem;
  --popper-theme-padding: 0.5rem 1rem;
  --popper-theme-box-shadow: none;

  .tooltip-icon {
    cursor: pointer;
    color: $label-color-2-dark;
    width: 20px;
    height: 20px;
    display: block;
  }

  .tooltip-message {
    @apply text-sm;
  }
}
</style>